import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import officeslider1 from "../Assets/slider/1.jpg"
import officeslider2 from "../Assets/slider/1-1.jpeg"

import officeslider3 from "../Assets/slider/2.jpeg"
import officeslider4 from "../Assets/slider/2-2.png"

import officeslider5 from "../Assets/slider/3.jpeg"
import officeslider6 from "../Assets/slider/3-3.jpg"

import officeslider7 from "../Assets/slider/4.jpeg"
import officeslider8 from "../Assets/slider/4-4.png"

// import officeslider9 from "../Assets/slider/5.jpeg"
// import officeslider10 from "../Assets/slider/5-5.MOV"



const TransformationShowcase = () => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const containerRef = useRef(null);

  // 5 Premium Custom Spatial Datasets
  const showcaseData = [
    {
      num: '01',
      title: 'office1',
      scope: 'Full Architecture Overlay',
      before: officeslider2,
      after: officeslider1,
    },
    {
      num: '02',
      title: 'Travertine Living Room',
      scope: 'Luminance Balancing',
      before: officeslider3,
      after: officeslider4
    },
    {
      num: '03',
      title: 'Bespoke Oak Dining Area',
      scope: 'Organic Spatial Layering',
      before: officeslider5,
      after: officeslider6
    },
    {
      num: '04',
      title: 'Alabaster Bedroom Vault',
      scope: 'Structural Symmetry Planning',
      before: officeslider7,
      after: officeslider8
    },
    // {
    //   num: '05',
    //   title: 'The Quartz Workspace',
    //   scope: 'Ergonomic Perimeter Layout',
    //   before: officeslider9,
    //   after: officeslider10
    // }
  ];

  const current = showcaseData[activeIdx];

  const theme = {
    background: '#F8F6F2',   
    surface: '#FFFFFF',      
    accent: '#D4AF37',       
    textMain: '#2C302E',     
    textMuted: '#7A827E',    
    border: 'rgba(44, 48, 46, 0.08)' 
  };

  const selectSuite = (idx) => {
    if (idx === activeIdx) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveIdx(idx);
      setSliderPosition(50);
      setIsTransitioning(false);
    }, 350);
  };

  // Processing Slide Metrics
  const handleMove = (clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    let position = (x / rect.width) * 100;
    if (position < 0) position = 0;
    if (position > 100) position = 100;
    setSliderPosition(position);
  };

  useEffect(() => {
    const handleMouseUp = () => setIsDragging(false);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('touchend', handleMouseUp);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchend', handleMouseUp);
    };
  }, []);

  const stylingExtensions = `
    @keyframes lineGrow { from { width: 0; } to { width: 40px; } }
    .active-indicator-line { animation: lineGrow 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    
    @keyframes subtleReveal { from { opacity: 0; transform: scale(1.02); } to { opacity: 1; transform: scale(1); } }
    .media-canvas-reveal { animation: subtleReveal 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

    /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
    @media (max-width: 991px) {
      .showcase-asymmetric-split { flex-direction: column !important; gap: 40px !important; }
      .left-navigation-sidebar { min-width: 100% !important; flex: none !important; border-right: none !important; padding-right: 0 !important; }
      .right-interactive-canvas { min-width: 100% !important; flex: none !important; height: 380px !important; }
      .vertical-tabs-stack { flex-direction: row !important; overflow-x: auto !important; padding-bottom: 15px !important; gap: 20px !important; scrollbar-width: none; }
      .vertical-tabs-stack::-webkit-scrollbar { display: none; }
      .tab-item-node { border-bottom: none !important; padding: 0 !important; }
      .tab-item-node h3 { font-size: 1.1rem !important; white-space: nowrap !important; }
      .tab-item-scope, .tab-item-num, .active-indicator-line { display: none !important; }
      .showcase-screen-wrapper { padding: 30px 20px !important; }
    }
  `;

  return (
    <div className="showcase-screen-wrapper" style={{
      background: theme.background,
      minHeight: '100vh',
      color: theme.textMain,
      padding: '40px 60px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      boxSizing: 'border-box',
      overflowX: 'hidden'
    }}>
      <style>{stylingExtensions}</style>

      {/* Header Context Bar */}
     

      {/* Asymmetric Core Screen Grid Split */}
      <div className="showcase-asymmetric-split" style={{ display: 'flex', gap: '80px', marginTop: '20px', alignItems: 'stretch' }}>
        
        {/* ==================== LEFT ROW: SIDEBAR CONTROLLER ==================== */}
        <div className="left-navigation-sidebar" style={{ flex: '1', minWidth: '340px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div>
            <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Spatial Evolution</span>
            <h1 style={{ fontSize: '2.8rem', fontWeight: '300', margin: '10px 0 40px 0', letterSpacing: '0.5px', lineHeight: '1.1' }}>Architectural Transformations</h1>
            
            {/* Tab Stack Wrapper */}
            <div className="vertical-tabs-stack" style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
              {showcaseData.map((project, idx) => {
                const isSelected = activeIdx === idx;
                return (
                  <div 
                    key={idx}
                    className="tab-item-node"
                    onClick={() => selectSuite(idx)}
                    style={{
                      cursor: 'pointer',
                      borderBottom: `1px solid ${isSelected ? 'rgba(44, 48, 46, 0.15)' : 'rgba(44, 48, 46, 0.03)'}`,
                      paddingBottom: '15px',
                      transition: 'all 0.3s ease',
                      position: 'relative'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '15px' }}>
                      <span className="tab-item-num" style={{ fontSize: '0.85rem', fontWeight: '700', color: isSelected ? theme.accent : theme.textMuted, fontFamily: 'monospace' }}>{project.num}</span>
                      <h3 style={{ margin: 0, fontSize: '1.3rem', fontWeight: isSelected ? '600' : '400', color: isSelected ? theme.textMain : theme.textMuted, transition: 'color 0.2s' }}>{project.title}</h3>
                    </div>
                    
                    {isSelected && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '8px' }}>
                        <div className="active-indicator-line" style={{ height: '1px', background: theme.accent }} />
                        <span className="tab-item-scope" style={{ fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px' }}>{project.scope}</span>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* ==================== RIGHT ROW: SLIDER CANVAS ==================== */}
        <div 
          className="right-interactive-canvas"
          ref={containerRef}
          onMouseMove={(e) => isDragging && handleMove(e.clientX)}
          onTouchMove={(e) => isDragging && e.touches.length > 0 && handleMove(e.touches[0].clientX)}
          style={{
            flex: '1.4',
            minWidth: '360px',
            position: 'relative',
            borderRadius: '24px',
            overflow: 'hidden',
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            boxShadow: '0 25px 55px rgba(44, 48, 46, 0.06)',
            cursor: isDragging ? 'ew-resize' : 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            height: '560px'
          }}
        >
          {/* Main Rendering Shield Frame */}
          <div className={isTransitioning ? '' : 'media-canvas-reveal'} style={{ width: '100%', height: '100%', opacity: isTransitioning ? 0.3 : 1, transition: 'opacity 0.25s ease', }}>
            
            {/* COMPLETED "AFTER" IMAGE LAYER */}
            <img src={current.after} alt="Completed Suite Look" style={{ width: '100%', height: '100%', objectFit: 'fill', pointerEvents: 'none' }} />
            <div className="label-badge" style={{ position: 'absolute', bottom: '20px', right: '20px', background: theme.surface, color: theme.textMain, padding: '8px 18px', borderRadius: '30px', fontSize: '0.8rem', fontWeight: '700', letterSpacing: '1px', zIndex: 5, boxShadow: '0 4px 10px rgba(0,0,0,0.04)' }}>AFTER DESIGN</div>

            {/* CLIPPED "BEFORE" IMAGE LAYER */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: `${sliderPosition}%`, height: '100%', overflow: 'hidden', zIndex: 2 }}>
              <img 
                src={current.before} 
                alt="Before Setup State" 
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: containerRef.current ? containerRef.current.offsetWidth : '50vw',
                  height: containerRef.current ? containerRef.current.offsetHeight : '560px',
                  objectFit: 'cover',
                  pointerEvents: 'none'
                }} 
              />
            </div>
            <div className="label-badge" style={{ position: 'absolute', bottom: '20px', left: '20px', background: theme.textMain, color: '#FFF', padding: '8px 18px', borderRadius: '30px', fontSize: '0.8rem', fontWeight: '700', letterSpacing: '1px', zIndex: 5 }}>BEFORE RAW</div>

            {/* SLIDER CONTROLLER HANDLE BAR */}
            <div 
              onMouseDown={() => setIsDragging(true)}
              onTouchStart={() => setIsDragging(true)}
              style={{ position: 'absolute', top: 0, left: `${sliderPosition}%`, width: '2px', height: '100%', background: theme.accent, zIndex: 4, cursor: 'ew-resize', transform: 'translateX(-50%)' }}
            >
              <div className="animate-pulse-handle" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '46px', height: '46px', borderRadius: '50%', background: theme.surface, border: `2px solid ${theme.accent}`, display: 'flex', justifyContent: 'center', alignItems: 'center', boxShadow: '0 6px 20px rgba(0,0,0,0.12)', color: theme.accent, fontWeight: '700', fontSize: '1.2rem' }}>‹›</div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default TransformationShowcase;

// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import officeslider1 from "../Assets/slider/1.jpg"
// import officeslider2 from "../Assets/slider/1-1.jpeg"

// import officeslider3 from "../Assets/slider/2.jpeg"
// import officeslider4 from "../Assets/slider/2-2.png"

// import officeslider5 from "../Assets/slider/3.jpeg"
// import officeslider6 from "../Assets/slider/3-3.jpg"

// import officeslider7 from "../Assets/slider/4.jpeg"
// import officeslider8 from "../Assets/slider/4-4.png"

// const TransformationShowcase = () => {
//   const [activeIdx, setActiveIdx] = useState(0);
//   const [sliderPosition, setSliderPosition] = useState(50); // Direct crossfade factor
//   const [isDragging, setIsDragging] = useState(false);
//   const [isTransitioning, setIsTransitioning] = useState(false);

//   const showcaseData = [
//     { num: '01', title: 'Office Workspace', scope: 'Full Spatial Layout', before: officeslider2, after: officeslider1 },
//     { num: '02', title: 'Travertine Living Room', scope: 'Luminance Balancing', before: officeslider3, after: officeslider4 },
//     { num: '03', title: 'Bespoke Oak Dining', scope: 'Organic Material Layering', before: officeslider5, after: officeslider6 },
//     { num: '04', title: 'Alabaster Bedroom Vault', scope: 'Symmetry Realignment', before: officeslider7, after: officeslider8 }
//   ];

//   const current = showcaseData[activeIdx];

//   const theme = {
//     background: '#F8F6F2',   
//     surface: '#FFFFFF',      
//     accent: '#D4AF37',       
//     textMain: '#2C302E',     
//     textMuted: '#7A827E',    
//     border: 'rgba(44, 48, 46, 0.08)' 
//   };

//   const selectSuite = (idx) => {
//     if (idx === activeIdx) return;
//     setIsTransitioning(true);
//     setTimeout(() => {
//       setActiveIdx(idx);
//       setSliderPosition(50);
//       setIsTransitioning(false);
//     }, 300);
//   };

//   // Safe Track Drag Handler Calculation
//   const processMove = (clientX, targetEl) => {
//     if (!targetEl) return;
//     const rect = targetEl.getBoundingClientRect();
//     const x = clientX - rect.left;
//     let position = (x / rect.width) * 100;
//     if (position < 0) position = 0;
//     if (position > 100) position = 100;
//     setSliderPosition(position);
//   };

//   useEffect(() => {
//     const stopDrag = () => setIsDragging(false);
//     window.addEventListener('mouseup', stopDrag);
//     window.addEventListener('touchend', stopDrag);
//     return () => {
//       window.removeEventListener('mouseup', stopDrag);
//       window.removeEventListener('touchend', stopDrag);
//     };
//   }, []);

//   const uniqueStyles = `
//     @keyframes lineGrow { from { width: 0; } to { width: 40px; } }
//     .active-line-indicator { animation: lineGrow 0.4s ease forwards; }

//     @keyframes fadeLayerIn { from { opacity: 0; } to { opacity: 1; } }
//     .canvas-fade-reveal { animation: fadeLayerIn 0.5s ease-out forwards; }

//     @media (max-width: 991px) {
//       .showcase-split-grid { flex-direction: column !important; gap: 40px !important; }
//       .sidebar-nav-deck { min-width: 100% !important; flex: none !important; }
//       .slider-interactive-stage { min-width: 100% !important; flex: none !important; height: 360px !important; }
//       .horizontal-tab-scroller { flex-direction: row !important; overflow-x: auto !important; padding-bottom: 12px !important; gap: 20px !important; scrollbar-width: none; }
//       .horizontal-tab-scroller::-webkit-scrollbar { display: none; }
//       .responsive-card-node { border-bottom: none !important; padding: 0 !important; }
//       .responsive-card-node h3 { font-size: 1.1rem !important; white-space: nowrap !important; }
//       .responsive-meta-text { display: none !important; }
//       .showcase-screen-container { padding: 30px 20px !important; }
//     }
//   `;

//   return (
//     <div className="showcase-screen-container" style={{
//       background: theme.background,
//       minHeight: '100vh',
//       color: theme.textMain,
//       padding: '40px 60px',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       boxSizing: 'border-box',
//       overflowX: 'hidden'
//     }}>
//       <style>{uniqueStyles}</style>

//       {/* Return Navigation Rule */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
//         <Link to="/" style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px' }}>
//           ← Back to Main Screen
//         </Link>
//       </div>

//       {/* Main Screen Layout Split */}
//       <div className="showcase-split-grid" style={{ display: 'flex', gap: '80px', marginTop: '20px', alignItems: 'stretch' }}>
        
//         {/* ==================== LEFT ROW: SIDEBAR CONTROLLER ==================== */}
//         <div className="sidebar-nav-deck" style={{ flex: '1', minWidth: '340px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
//           <div>
//             <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Spatial Evolution</span>
//             <h1 style={{ fontSize: '2.8rem', fontWeight: '300', margin: '10px 0 40px 0', letterSpacing: '0.5px', lineHeight: '1.1' }}>Architectural Transformations</h1>
            
//             {/* Interactive Vertical Tab Selector Stack */}
//             <div className="horizontal-tab-scroller" style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
//               {showcaseData.map((project, idx) => {
//                 const isSelected = activeIdx === idx;
//                 return (
//                   <div 
//                     key={idx}
//                     className="responsive-card-node"
//                     onClick={() => selectSuite(idx)}
//                     style={{
//                       cursor: 'pointer',
//                       borderBottom: `1px solid ${isSelected ? 'rgba(44, 48, 46, 0.15)' : 'rgba(44, 48, 46, 0.03)'}`,
//                       paddingBottom: '15px',
//                       transition: 'all 0.3s ease'
//                     }}
//                   >
//                     <div style={{ display: 'flex', alignItems: 'baseline', gap: '15px' }}>
//                       <span className="responsive-meta-text" style={{ fontSize: '0.85rem', fontWeight: '700', color: isSelected ? theme.accent : theme.textMuted, fontFamily: 'monospace' }}>{project.num}</span>
//                       <h3 style={{ margin: 0, fontSize: '1.3rem', fontWeight: isSelected ? '600' : '400', color: isSelected ? theme.textMain : theme.textMuted }}>{project.title}</h3>
//                     </div>
                    
//                     {isSelected && (
//                       <div className="responsive-meta-text" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '8px' }}>
//                         <div className="active-line-indicator" style={{ height: '1px', background: theme.accent }} />
//                         <span style={{ fontSize: '0.8rem', color: theme.textMuted, textTransform: 'uppercase', letterSpacing: '1px' }}>{project.scope}</span>
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>

//         {/* ==================== RIGHT ROW: INTERLOCKING INTERACTIVE OPACITY FILM SLIDER ==================== */}
//         <div 
//           className="slider-interactive-stage"
//           onMouseMove={(e) => isDragging && processMove(e.clientX, e.currentTarget)}
//           onTouchMove={(e) => isDragging && e.touches.length > 0 && processMove(e.touches[0].clientX, e.currentTarget)}
//           style={{
//             flex: '1.4',
//             minWidth: '360px',
//             position: 'relative',
//             borderRadius: '24px',
//             overflow: 'hidden',
//             background: theme.surface,
//             border: `1px solid ${theme.border}`,
//             boxShadow: '0 25px 55px rgba(44, 48, 46, 0.06)',
//             cursor: isDragging ? 'ew-resize' : 'default',
//             userSelect: 'none',
//             WebkitUserSelect: 'none',
//             height: '560px'
//           }}
//         >
//           {/* Main Media Core Wrapper */}
//           <div className={isTransitioning ? '' : 'canvas-fade-reveal'} style={{ width: '100%', height: '100%', opacity: isTransitioning ? 0.2 : 1, transition: 'opacity 0.2s ease', position: 'relative' }}>
            
//             {/* LAYER 1: THE COMPLETED "AFTER" STATE (Sits solid in the background) */}
//             <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
//               <img 
//                 src={current.after} 
//                 alt="Completed Elegant Space" 
//                 style={{ width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} 
//               />
//               <div style={{ position: 'absolute', bottom: '20px', right: '20px', background: theme.surface, color: theme.textMain, padding: '8px 18px', borderRadius: '30px', fontSize: '0.8rem', fontWeight: '700', letterSpacing: '1px', zIndex: 5, boxShadow: '0 4px 10px rgba(0,0,0,0.04)' }}>AFTER DESIGN</div>
//             </div>

//             {/* LAYER 2: THE INTERLOCKING "BEFORE" STATE (Fades out seamlessly based on slider coordinates) */}
//             <div style={{ 
//               position: 'absolute', 
//               top: 0, 
//               left: 0, 
//               width: '100%', 
//               height: '100%', 
//               zIndex: 2,
//               // Calculates clean inverse opacity layout without cropping or shifting image widths
//               opacity: (100 - sliderPosition) / 100, 
//               transition: isDragging ? 'none' : 'opacity 0.2s ease'
//             }}>
//               <img 
//                 src={current.before} 
//                 alt="Raw Unfinished Room" 
//                 style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }} 
//               />
//               <div style={{ position: 'absolute', bottom: '20px', left: '20px', background: theme.textMain, color: '#FFF', padding: '8px 18px', borderRadius: '30px', fontSize: '0.8rem', fontWeight: '700', letterSpacing: '1px', zIndex: 5 }}>BEFORE RAW</div>
//             </div>

//             {/* ==================== UPPER DECK CONTROL TOGGLE SYSTEM ==================== */}
//             <div 
//               onMouseDown={() => setIsDragging(true)}
//               onTouchStart={() => setIsDragging(true)}
//               style={{ 
//                 position: 'absolute', 
//                 top: 0, 
//                 left: `${sliderPosition}%`, 
//                 width: '0px', 
//                 height: '100%', 
//                 zIndex: 10, 
//                 cursor: 'ew-resize'
//               }}
//             >
//               {/* Golden Separator Accent Rule line */}
//               <div style={{ position: 'absolute', top: 0, left: '-1px', width: '2px', height: '100%', background: theme.accent, boxShadow: '0 0 10px rgba(212,175,55,0.5)' }} />
              
//               {/* Circular Action Navigation Pointer Capsule */}
//               <div style={{ 
//                 position: 'absolute', 
//                 top: '50%', 
//                 left: '-23px', 
//                 transform: 'translateY(-50%)', 
//                 width: '46px', 
//                 height: '46px', 
//                 borderRadius: '50%', 
//                 background: theme.surface, 
//                 border: `2px solid ${theme.accent}`, 
//                 display: 'flex', 
//                 justifyContent: 'center', 
//                 alignItems: 'center', 
//                 boxShadow: '0 6px 20px rgba(44, 48, 46, 0.15)', 
//                 color: theme.accent, 
//                 fontWeight: '700', 
//                 fontSize: '1.2rem' 
//               }}>
//                 ‹›
//               </div>
//             </div>

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default TransformationShowcase;
